import React from "react";

const DataContext = React.createContext({});

export function DataProvider(props){
  const [categories, setCategories] = React.useState();
  const [items, setItems] = React.useState();
  // const [board, setBoard] = React.useState();

  const loadData = React.useCallback(()=>{
    if(window.__follozeCategoriesResult){
      setCategories(window.__follozeCategoriesResult);
      setItems(window.__follozeItemsResult);
    }
  }, [setCategories, setItems]);

  React.useEffect(() => {
    loadData();
    window.addEventListener('FollozeDataLoaded', loadData);
    return ()=>{
      window.removeEventListener('FollozeDataLoaded', loadData);
    }
  }, [loadData]);

  return (
    <DataContext.Provider value={{
      items, categories
    }}>
      {props.children}
    </DataContext.Provider>
  )

}

export const useData = () => {
  const store = React.useContext(DataContext);
  if (!store) {
    throw new Error("useData must be used within DataContext Provider");
  }
  return store;
};
